/**
 * Utility functions for analytics components
 */

/**
 * Format time in seconds to human-readable format
 * @param seconds - Time in seconds
 * @returns Formatted time string (e.g., "30s", "2m", "1h")
 */
export const formatTime = (seconds: number): string => {
  if (seconds < 60) return `${Math.round(seconds)}s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)}m`;
  return `${Math.round(seconds / 3600)}h`;
};

/**
 * Format percentage value
 * @param value - Percentage value (0-100)
 * @returns Formatted percentage string (e.g., "75%")
 */
export const formatPercentage = (value: number): string => {
  return `${Math.round(value)}%`;
};

/**
 * Get color for sentiment analysis
 * @param sentiment - Sentiment string
 * @returns Hex color code
 */
export const getSentimentColor = (sentiment: string | null | undefined): string => {
  if (!sentiment) return "#6B7280";

  const sentimentLower = sentiment.toLowerCase();
  if (sentimentLower.includes("positive")) return "#10B981";
  if (sentimentLower.includes("negative")) return "#EF4444";
  if (sentimentLower.includes("neutral")) return "#6B7280";
  if (sentimentLower.includes("confused")) return "#F59E0B";
  if (sentimentLower.includes("excited")) return "#3B82F6";

  return "#6B7280";
};

/**
 * Get color for status
 * @param status - Status string
 * @returns Hex color code
 */
export const getStatusColor = (status: string): string => {
  switch (status) {
    case "completed":
      return "#10B981"; // green
    case "inProgress":
      return "#3B82F6"; // blue
    case "notStarted":
      return "#6B7280"; // gray
    default:
      return "#6B7280";
  }
};
